<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20 13H4a1 1 0 010-2h16a1 1 0 010 2zM20 6H4a1 1 0 010-2h16a1 1 0 010 2zM20 20H4a1 1 0 010-2h16a1 1 0 010 2z"/></svg>